import { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { connect } from 'react-redux';
import parse from "html-react-parser";
import swal from 'sweetalert';

// icn
import { formatPriceUSD, getFormattedSize } from "helpers/common";
import * as actions from "store/actions";
import { getStorageUprgadePlans, purchaseStoragePlan } from "store/services/documentStorgeService";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { documentStorage } from "Routes/paths";
//imported

const UpgradeStorage = ({ dispatch }) => {
  const navigate = useNavigate();
  const [upgradePlansList, setUpgradePlansList] = useState(null);
  const [isLoading, setLoading] = useState(false);
  // const [storageDetails, setStorageDetails] = useState(null);

  const [searchParams] = useSearchParams();
  const status = searchParams.get("status");

  useEffect(() => {
    if (!status) {
      return;
    }

    async function upgradeCallback() {
      let success = status === "success";

      await swal({
        title: success ? "Payment Successful!" : "Purchase Failed!",
        text: success
          ? "Your payment has been processed successfully."
          : "Something went wrong. Please try again or contact support.",
        icon: success ? "success" : "error",
        showCancelButton: !success,
      });

      if (success) {
        navigate(documentStorage);
      }
    }

    upgradeCallback();
  }, [status]);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      setLoading(true);
      dispatch(actions.persist_store({ loader: true }));
      let response = await Promise.all([
        getStorageUprgadePlans(),
        // getStorageInfo(),
      ])
      if (!response?.length > 1) {
        throw new Error("Promise reponse was not ok");
      }

      let upgradePlans = response[0];
      if (upgradePlans?.success && upgradePlans?.body?.length) {
        setUpgradePlansList(upgradePlans?.body);
      }

      // let storageInfo = response[1];
      // if(storageInfo?.success) {
      //   setStorageDetails(storageInfo?.body);
      // }
      dispatch(actions.persist_store({ loader: false }));
      setLoading(false);
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      setLoading(false);
      console.error("Error fetching storage details", err);
    }
  };

  const handlePurchase = async (planId) => {
    try {
      dispatch(actions.persist_store({ loader: true }));

      let response = await purchaseStoragePlan(planId);

      dispatch(actions.persist_store({ loader: false }));

      if (response?.body?.url) {
        window.location.href = response?.body?.url;
      }
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.error("Error getting payment link", err);
    }
  };

  return (
    <section className="container-fluid">
      <div className="top py-2">
        <h3 className="m-0 py-1 fw-bold">Get more storage</h3>
      </div>
      <div className="subscription-info py-3">
        <Row className="py-2 px-5">
          {isLoading ? (
            <p>Loading...</p>
          ) : upgradePlansList?.length ? upgradePlansList?.map((plan, index) => {
            return (
              <Col lg={6} className="my-3">
                <div key={index} className="commonCardBox PricingCard p-3">
                  <div className="text-center">
                    <h5 className="m-0 text-dark fw-bold capitalize mb-1">
                      {plan?.plan_name}
                    </h5>
                    {/* <h3 className="m-0 mb-1">
                      {getFormattedSize(plan?.storage_size || 0)}
                    </h3> */}
                    <h4 className="m-0 my-3">
                      <strong>{formatPriceUSD(plan?.price)}</strong> / {plan?.duration} Days
                    </h4>
                    <div className="my-3">
                      {parse(plan?.description)}
                    </div>
                  </div>
                  <div className="text-center mt-3">
                    <Button
                      className="commonBtn btnSm"
                      onClick={() => handlePurchase(plan.id)}
                    >
                      Purchase
                    </Button>
                  </div>
                </div>
              </Col>
            )
          }) : (
            <Col lg={12}>
              <p>No plans found</p>
            </Col>
          )}
        </Row>
      </div>
      <div className="py-1 mb-4">
        <Link to={documentStorage}>
          <i className="fa fa-arrow-left me-2" aria-hidden="true"></i>
          Go Back
        </Link>
      </div>
    </section>
  );
};


const mapStateToPros = (state) => {
  return {}
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(UpgradeStorage);
